import type { RenderTextBox } from '@lite-workspace/shared/canvas-engine/core';
import { textLayoutAtLeast, TEXT_LAYOUT_FAUX_BOLD } from '@lite-workspace/text-layout';
// eslint-disable-next-line @nx/enforce-module-boundaries -- leaf constant; barrel pulls Angular/Konva, breaks this lib's vitest
import { PSD_FAUX_BOLD_ADVANCE_RATIO } from '../../../canvas-engine/src/lib/svg/text-constants';

/** Faux Bold by Photoshop's rule: stroke by the on-screen size, glyphs spread for it. Mirror of Rust `faux_bold_spreads`. */
export function fauxBoldSpreads(box: Pick<RenderTextBox, 'fauxBold' | 'textLayout'>): boolean {
  return !!box.fauxBold && textLayoutAtLeast(box.textLayout, TEXT_LAYOUT_FAUX_BOLD);
}

/** Extra advance per glyph, in em of the on-screen size. */
export function fauxBoldAdvanceEm(box: Pick<RenderTextBox, 'fauxBold' | 'textLayout'>): number {
  return fauxBoldSpreads(box) ? PSD_FAUX_BOLD_ADVANCE_RATIO : 0;
}
